import { useDispatch } from "react-redux";
import { newPost, getTrends } from "../../redux/actions/postActions";
import PostForm from "./PostForm";
import { useTranslation } from "react-i18next";

const NewPostForm = ({
  onlyVideo,
  isAd,
  isPollPost,
  isRacePost,
  prependValue,
  onComplete,
  exam,
  handleExamChange,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const onSubmit = (formData) => {
    if (isAd) {
      formData.append("isAd", true);
    }
    return new Promise((resolve, reject) => {
      dispatch(newPost(formData))
        .then((result) => {
          // Check if post was created successfully
          if (result.type === "post/newPost/fulfilled") {
            // Add a small delay to ensure server has processed the post
            setTimeout(() => {
              dispatch(getTrends()).catch((error) => {
                console.warn(
                  "Failed to refresh trends after post creation:",
                  error,
                );
              });
            }, 1000); // 1 second delay
          }
          resolve(result);
        })
        .catch(reject);
      if (typeof onComplete === "function") onComplete();
    });
  };

  return (
    <PostForm
      onlyVideo={onlyVideo}
      onSubmit={onSubmit}
      prependValue={prependValue}
      placeholder={isAd ? t("PostAdPlaceholder") : t("PostPlaceholder")}
      buttonText={isAd ? t("PostAdButton") : t("PostButton")}
      isPollPost={isPollPost}
      isRacePost={isRacePost}
      exam={exam}
      handleExamChange={handleExamChange}
    />
  );
};

export default NewPostForm;

